//Action AUTH
export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_LOAD = "AUTH_LOAD";
export const AUTH_ERROR_REMOVE = "AUTH_ERROR_REMOVE";
export const AUTH_MODAL_STATUS = "AUTH_MODAL_STATUS";
export const AUTH_SET_SERVER = "AUTH_SET_SERVER";
export const AUTH_RELOAD_CATEGORY = "AUTH_RELOAD_CATEGORY";
export const AUTH_NOTIF_COUNT = "AUTH_NOTIF_COUNT";

export const AUTH_VERIFYSEND_LOAD = "AUTH_VERIFYSEND_LOAD";
export const AUTH_VERIFICATION_LOAD = "AUTH_VERIFICATION_LOAD";

//ACTION REGISTER
export const REGISTER_START = "REGISTER_START";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const REGISTER_LOAD = "REGISTER_LOAD";
export const REGISTER_CLEAR = "REGISTER_CLEAR";

//ACTION ROUTER
export const ROUTER_CHOOSE = "ROUTER_CHOOSE";
export const ROUTER_NOTIF_TOP = "ROUTER_NOTIF_TOP";

//Action Questions
export const QUESTION_SEARCH = "QUESTION_SEARCH";
export const QUESTION_OPEN_BOX = "QUESTION_OPEN_BOX";
export const QUESTION_FETCH_PARAMETER = "QUESTION_FETCH_PARAMETER";
export const QUESTION_FETCH_MORE = "QUESTION_FETCH_MORE";
export const QUESTION_SAVE_FETCH = "QUESTION_SAVE_FETCH";
export const QUESTION_UPDATE_OBJECT = "QUESTION_UPDATE_OBJECT";

export const QUESTION_EDIT = "QUESTION_EDIT";
export const QUESTION_CATEGORY_EDIT = "QUESTION_CATEGORY_EDIT";
export const QUESTION_REMOVE = "QUESTION_REMOVE";

export const QUESTION_FEED_TIME = "QUESTION_FEED_TIME";
export const QUESTION_FEED_NEW_RECIVE = "QUESTION_FEED_NEW_RECIVE";

//Action Answer
export const ANSWER_EDIT = "ANSWER_EDIT";
export const ANSWER_REMOVE = "ANSWER_REMOVE";

//Action Comment
export const COMMENT_EDIT = "COMMENT_EDIT";
export const COMMENT_REMOVE = "COMMENT_REMOVE";

//ACTION REPORT
export const REPORT_LOADING = "REPORT_LOADING";
export const REPORT_OPEN = "REPORT_OPEN";
export const REPORT_CLOSE = "REPORT_CLOSE";
export const REPORT_COMPLETE = "REPORT_COMPLETE";
export const REPORT_ERROR = "REPORT_ERROR";
